export {MidiRecorderMessageEvent}

class MidiRecorderMessageEvent implements WebMidi.MIDIMessageEvent{
    readonly AT_TARGET: number = 0;
    readonly BUBBLING_PHASE: number = 0;
    readonly CAPTURING_PHASE: number = 0;
    readonly NONE: number = 0;
    readonly bubbles: boolean = false;
    cancelBubble: boolean = true;
    readonly cancelable: boolean = false;
    readonly composed: boolean = false;
    readonly currentTarget: EventTarget | null = null;
    data: Uint8Array = new Uint8Array();
    readonly defaultPrevented: boolean = true;
    readonly eventPhase: number = 0;
    readonly isTrusted: boolean = true;
    receivedTime: number = 0;
    returnValue: boolean = true;
    readonly srcElement: EventTarget | null = null;
    readonly target: EventTarget | null = null;
    readonly timeStamp: number = 0;
    readonly type: string = "";

    constructor(data: number[] | Uint8Array, timestamp:number) {
        this.data = Uint8Array.from(data);
        this.timeStamp = timestamp;
    }

    composedPath(): EventTarget[];
    composedPath(): EventTarget[];
    composedPath(): EventTarget[] {
        return [];
    }

    initEvent(type: string, bubbles?: boolean, cancelable?: boolean): void {
    }

    preventDefault(): void {
    }

    stopImmediatePropagation(): void {
    }

    stopPropagation(): void {
    }

}